import { getAllCapitalesSlugs } from "./utils/provinceMapping";

// Capitales de provincia para prerendering de estadísticas
const capitales = getAllCapitalesSlugs();
const capitalesRoutesEs = capitales.map((slug) => `/estadisticas/${slug}`);
const capitalesRoutesEn = capitales.map((slug) => `/en/statistics/${slug}`);

// Rutas estáticas para prerendering (SEO)
// No incluye rutas dinámicas como /historial/:id, /configuracion, etc.
export const prerenderRoutes = [
  // Español
  "/",
  "/test-velocidad",
  "/mapa-cobertura",
  "/datos-abiertos",
  "/estadisticas",
  "/cnmc-data",
  "/historial",
  "/servicios",
  "/preguntas-frecuentes",
  "/aplicaciones-moviles",
  "/informacion-legal",
  "/accesibilidad",
  "/mapa-sitio",
  "/politica-cookies",
  "/opiniones",
  "/medios",
  // Estadísticas por capital de provincia (ES)
  ...capitalesRoutesEs,
  // Inglés (con trailing slash para generar /en/index.html)
  "/en/",
  "/en/speed-test",
  "/en/coverage-map",
  "/en/open-data",
  "/en/statistics",
  "/en/cnmc-data",
  "/en/history",
  "/en/services",
  "/en/faq",
  "/en/mobile-apps",
  "/en/legal-information",
  "/en/accessibility",
  "/en/sitemap",
  "/en/cookie-policy",
  "/en/reviews",
  "/en/media",
  // Estadísticas por capital de provincia (EN)
  ...capitalesRoutesEn,
];
